import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-reg" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  class: "requiredLabel",
  for: "salutation"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { for: "title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  class: "requiredLabel",
  for: "firstname"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  class: "requiredLabel",
  for: "lastname"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "location" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "phone" }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "country-prefix" }, "+49", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "call-to-action mobile-bottom-nav"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)

import { computed, ref, onMounted, getCurrentInstance } from 'vue';
    import useVuelidate from '@vuelidate/core';
    import { required, requiredIf, numeric, helpers, maxLength, minLength } from '@vuelidate/validators';
    import { createCityZipCodeService } from '../services/cityZipCodeService';
    import { createAuthenticationService } from '../services/authenticationService';
    import { useI18n } from 'vue-i18n';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CandidateProfileForm',
  props: ["modelValue", "showButtons", "isDirectSignUp"],
  emits: ['next', 'previous', 'submit'],
  setup(__props, { emit: __emit }) {

    const emit = __emit;
    const props = __props;

    const { t } = useI18n();

    const form = ref(null);
    const zipAndCity = ref();
    const zipCodes = ref([]);
    const salutations = ref([t("salutations.mr"), t("salutations.mrs")]);

    const creationOption = ref("standalone");
    const titles = ref([null, "Dr.", "Prof.", "Prof. Dr."]);

    const app = getCurrentInstance();
    const authenticationService = createAuthenticationService(app);
    const user = ref({ ...props.modelValue });

    const rules = computed(() => {
        return {
            salutation: { required: helpers.withMessage("Eingabe wird benötigt", required) },
            firstName: { required: helpers.withMessage("Eingabe wird benötigt", required) },
            lastName: { required: helpers.withMessage("Eingabe wird benötigt", required) },
            zipCode: {
                requiredIf: helpers.withMessage(t("Eingabe wird benötigt"), requiredIf(() => {
                    return !props.isDirectSignUp;
                })),
                numeric: helpers.withMessage("validate.numeric.error", numeric),
                minLength: helpers.withMessage("validate.zipcode.error", minLength(5)),
                maxLength: helpers.withMessage("validate.zipcode.error", maxLength(5))
            },
            phoneNumber: {
                requiredIf: helpers.withMessage(t("Eingabe wird benötigt"), requiredIf(() => {
                    return !props.isDirectSignUp;
                })),
            },
            academicTitle: {},
        }
    });

    const truncatedPhoneNumber = computed({
        get: () => {
            if (user.value?.phoneNumber?.indexOf('+49') == 0)
                return user.value.phoneNumber.substring(3).trim();
            return user.value.phoneNumber;
        },
        set: (val) => {
            user.value.phoneNumber = "+49 " + val;
        }
    });

    const fetchCityZipCodes = async function () {
        const service = await createCityZipCodeService(app);
        const response = await service.getAll()
        zipCodes.value = response.data;

        if (user.value.zipCodeIds == undefined || user.value.zipCodeIds == null || user.value.zipCodeIds.length == 0)
            return;
        for (let i = 0; i < user.value.zipCodeIds.length; i++) {
            selectedZipCodes.value.push(await (await service.getById(user.value.zipCodeIds[i])).data);
        }
    }

    const userMail = ref("");

    const showMessageOnError = ref(false);

    onMounted(async () => {
        userMail.value = await authenticationService.getUserEmail();
        await fetchCityZipCodes();
        zipAndCity.value = await requestNameByZip(user.value.zipCode);
    });

    const requestNameByZip = async (zip: string) => {
        const service = await createCityZipCodeService(app);
        if (zip) {
            const result = await service.zip(zip);

            if (result.status == 200) {
                if (result.data) {
                    const data = result.data as any;
                    return data.zip + " " + data.cityName;
                }
            }
        }

        return null;
    };


    const v$ = useVuelidate(rules, user);
    const validate = () => {
        v$.value.$touch();
        if (v$.value.$invalid) {
            return v$.value.$error;
        }
    }

    const selectedZipCodes = ref([]);

    const locations = ref();

    const loadLocations = async (event) => {
        if (event.query.trim().length < 3) {
            locations.value = [];
        }
        else {
            const service = await createCityZipCodeService(app);
            const data = await service.locations(event.query.trim());
            locations.value = data.data;
        }
    };

const locationItemSelected = (event) => {
    if (event.value) {
        user.value.zipCode = event.value?.split(' ')[0];
    }
}

    const next = () => {
        if (!validate()) {
            user.value.zipCodeIds = selectedZipCodes.value.map(x => x.id);
            emit("next", user.value);
        }
        showMessageOnError.value = true;
    };

    const submit = () => {
        if (!validate()) {
            user.value.zipCodeIds = selectedZipCodes.value.map(x => x.id);
            emit("submit", user.value);
        }
        showMessageOnError.value = true;
    };

    const prev = () => {
        emit("previous", user.value);
    };

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_Dropdown, {
            id: "salutation",
            "data-cy": "wizard-salutation",
            modelValue: _unref(v$).salutation.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).salutation.$model) = $event)),
            options: salutations.value,
            class: _normalizeClass({'p-invalid':_unref(v$).salutation.$error})
          }, null, 8, ["modelValue", "options", "class"]),
          _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)("salutation")) + " *", 1)
        ]),
        (showMessageOnError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).salutation.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "p-error",
                  key: index
                }, _toDisplayString(_unref(t)(error.$message)), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_Dropdown, {
            id: "title",
            modelValue: _unref(v$).academicTitle.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).academicTitle.$model) = $event)),
            options: titles.value,
            class: _normalizeClass({'p-invalid':_unref(v$).academicTitle.$error})
          }, null, 8, ["modelValue", "options", "class"]),
          _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)("academic.title")), 1)
        ]),
        (showMessageOnError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).academicTitle.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "p-error",
                  key: index
                }, _toDisplayString(_unref(t)(error.$message)), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_InputText, {
            id: "firstName",
            "data-cy": "wizard-firstName",
            modelValue: user.value.firstName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.firstName) = $event)),
            type: "text",
            class: _normalizeClass({'p-invalid':_unref(v$).firstName.$error})
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("profile.form.firstname")) + " *", 1)
        ]),
        (showMessageOnError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).firstName.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "p-error",
                  key: index
                }, _toDisplayString(_unref(t)(error.$message)), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_InputText, {
            id: "lastName",
            "data-cy": "wizard-lastName",
            modelValue: _unref(v$).lastName.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).lastName.$model) = $event)),
            type: "text",
            class: _normalizeClass({'p-invalid':_unref(v$).lastName.$error})
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)("profile.form.lastname")) + " *", 1)
        ]),
        (showMessageOnError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).lastName.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "p-error",
                  key: index
                }, _toDisplayString(_unref(t)(error.$message)), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_AutoComplete, {
            modelValue: zipAndCity.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((zipAndCity).value = $event)),
            forceSelection: "",
            autoHighlight: true,
            suggestions: locations.value,
            inputClass: {'p-invalid':_unref(v$).zipCode.$error},
            onComplete: _cache[5] || (_cache[5] = ($event: any) => (loadLocations($event))),
            onItemSelect: _cache[6] || (_cache[6] = ($event: any) => (locationItemSelected($event))),
            onClear: _cache[7] || (_cache[7] = ($event: any) => (user.value.zipCode='')),
            id: "zipCode",
            "data-cy": "wizard-zipCode"
          }, null, 8, ["modelValue", "suggestions", "inputClass"]),
          _createElementVNode("label", {
            class: _normalizeClass([{'invalid': _unref(v$).zipCode.$error}, 'requiredLabel']),
            for: "zipCode"
          }, _toDisplayString(_unref(t)("place.of.residence.postcode") + (__props.isDirectSignUp ? "" : " *")), 3)
        ]),
        (showMessageOnError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).zipCode.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "p-error",
                  key: index
                }, _toDisplayString(_unref(t)(error.$message)), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", _hoisted_18, [
          _createVNode(_component_InputText, {
            id: "phoneNumber",
            "data-cy": "wizard-phoneNumber",
            modelValue: truncatedPhoneNumber.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((truncatedPhoneNumber).value = $event)),
            type: "tel",
            class: _normalizeClass({'p-invalid':_unref(v$).phoneNumber.$error})
          }, null, 8, ["modelValue", "class"]),
          _hoisted_19,
          _createElementVNode("label", {
            class: _normalizeClass([{'invalid': _unref(v$).zipCode.$error}, 'requiredLabel no-tooltip']),
            for: "phoneNumber"
          }, _toDisplayString(_unref(t)("phone.number") + (__props.isDirectSignUp ? "" : " *")), 3)
        ]),
        (showMessageOnError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).phoneNumber.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "p-error",
                  key: index
                }, _toDisplayString(_unref(t)(error.$message)), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.showButtons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (__props.isDirectSignUp)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                "data-cy": "button-profile-prev",
                class: "button-secondary button-back p-pl-3",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (prev()))
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createTextVNode(_toDisplayString(_unref(t)("back")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_23,
          (creationOption.value == 'standalone')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                "data-cy": "button-profile-next",
                class: "button-secondary button-next p-pr-3",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (next()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("continue")) + " ", 1),
                  _hoisted_24
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                "data-cy": "button-secondary button-next",
                class: "button-rectangle button-secondary",
                label: _unref(t)('finish'),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (submit()))
              }, null, 8, ["label"]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})